import { Component, Input } from '@angular/core';
import { SettingsProvider } from '@services/settings/settings';

@Component({
	selector: 'sn-warning',
	template: require('./sn-warning.html')
})
export class SnWarningComponent {
	@Input() warningClass: string;
	@Input() preLabelName: string;
	mainShootLabel: string;
	concatedString: string;
	constructor(private settingsProvider: SettingsProvider) {
		this.settingsProvider.customizeLabelsObservable.subscribe((data): void => {
			this.mainShootLabel = data.mainShootLabel;
		});
	}

	getTooltipMsg(): string {
		this.concatedString = `Another ${this.preLabelName} ${
			this.mainShootLabel
		} is at the same time`;
		return this.concatedString;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./shared/components/common/sn-warning/sn-warning.ts